"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M11.992 3.5s-7.5 0-9.383.495C1.6 4.28.77 5.12.489 6.155 0 8.062 0 12.009 0 12.009s0 3.96.49 5.836a3.073 3.073 0 002.119 2.146c1.897.51 9.383.51 9.383.51s7.516 0 9.399-.495a3.001 3.001 0 002.105-2.146C24 15.97 24 12.022 24 12.022s.015-3.96-.504-5.866a2.981 2.981 0 00-2.105-2.13C19.508 3.5 11.993 3.5 11.993 3.5zM9.607 8.361l6.24 3.646-6.24 3.632V8.361z" }), "YouTube");
//# sourceMappingURL=YouTube.js.map